import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    getCollectionPointForDropDown,
    saveCardUpload,
    employeeCardBulkUpload
};

async function getCollectionPointForDropDown(estateID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID='+estateID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function saveCardUpload(cardFilterModule){
    cardFilterModule.createdBy = parseInt(tokenDecoder.getUserIDFromToken());
    const response = await CommonPost('/api/Employee/UploadEmployeeCard', null, cardFilterModule);
    return response;
}

async function employeeCardBulkUpload(bulkModule){
    
    const response = await CommonPost('/api/Employee/EmployeeBulkUpload', null, bulkModule);
    return response;
}






